var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CriterionItem',{attrs:{"criterion":_vm.source,"formula":_vm.formula},on:{"onTagClick":function($event){return _vm.$emit('onTagClick', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }